import React, { useEffect, useState } from 'react';
import {
    DataGrid,
    Column,
    HeaderFilter,
    Search,
    ColumnFixing,
    Scrolling,
    FilterRow,
    FilterPanel,
    // Selection,
    Toolbar,
    Item
} from 'devextreme-react/data-grid';
import Button2 from 'devextreme-react/button';
import { Popup, ToolbarItem } from "devextreme-react/popup";
import { PencilSquareIcon, TrashIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';


import * as DynamicQueries from '../../services/DynamicQueries';


const CarList = () => {

    const [dataGrid, setDataGrid] = useState([]);
    const [dataBrands, setDataBrands] = useState([]);
    const [dataModels, setDataModels] = useState([]);
    const [dataSegments, setDataSegments] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [create, setCreate] = useState(false);
    const [update, setUpdate] = useState(false);
    const [code, setCode] = useState('');
    const [brand, setBrand] = useState(1);
    const [model, setModel] = useState(1);
    const [year, setYear] = useState('');
    const [version, setVersion] = useState('');
    const [segment, setSegment] = useState(1);
    const [listPrice, setListPrice] = useState('');
    const [salePrice, setSalePrice] = useState('');
    const [idCar, setIdCar] = useState('');
    const [showPopupDelete, setShowPopupDelete] = useState(false);


    const getCarsData = () => {
        DynamicQueries.getData('/getDataCars', 'cars').then((resp) => {
            setDataGrid(resp.data.cars)
        })
    };

    const getBrands = () => {
        DynamicQueries.getData('/getDataBrands', 'brands').then((resp) => {
            setDataBrands(resp.data.brands)
        })
    };

    const getModels = () => {
        DynamicQueries.getData('/getDataModels', 'models').then((resp) => {
            setDataModels(resp.data.models)
        })
    };

    const getSegments = () => {
        DynamicQueries.getData('/getDataSegments', 'segments').then((resp) => {
            setDataSegments(resp.data.segments)
        })
    };

    const saveButtonCarOptions = {
        text: "Guardar",
        onClick: () => {
            saveCar()
        },
    };

    const saveCar = () => {
        if (create) {
            DynamicQueries.dataWithParameters('/saveCar', 'cars', { code: code, brand: brand, model: model, year: year, version: version, segment: segment, listPrice: listPrice, salePrice: salePrice })
                .then((resp) => {
                    if (resp.data.errors) {
                        console.log("🚀 ~ .then ~ resp.data.errors:", resp.data.errors)
                    } else if (resp.data.message === 'Registro insertado') {
                        hidePopup();
                        getCarsData();
                    } else if (resp.data.message === 'Registro existente') {
                        console.log("🚀 ~ .then ~ resp.data.message:", resp.data.message)
                    }
                })
        } else if (update) {
            DynamicQueries.dataWithParameters('/updateCar', 'cars', { code: code, brand: brand, model: model, year: year, version: version, segment: segment, listPrice: listPrice, salePrice: salePrice, id: idCar })
                .then((resp) => {
                    if (resp.data.errors) {
                        console.log("🚀 ~ .then ~ resp.data.errors:", resp.data.errors)
                    } else if (resp.data.message === 'Registro actualizado') {
                        hidePopup();
                        getCarsData();
                    } else if (resp.data.message === 'Registro existente') {
                        console.log("🚀 ~ .then ~ resp.data.message:", resp.data.message)
                    }
                })
        }
    };

    const openPopup = () => {
        setCode('');
        setBrand(1);
        setModel(1);
        setYear('')
        setSegment(1);
        setListPrice('');
        setSalePrice('');
        setVersion('');
        setCreate(true);
        setUpdate(false);
        setShowPopup(true);
    };

    const hidePopup = () => {
        setShowPopup(false);
    };

    const cellRenderEdit = (data) => {
        let icon = <PencilSquareIcon className="h-6 w-6 text-black cursor-pointer" onClick={() => { openEditPopup(data.data) }} aria-hidden="true" />

        return icon
    }

    const openEditPopup = (data) => {
        setCode(data.version_code);
        setBrand(data.brand_id);
        setModel(data.model_id);
        setYear(data.year_name)
        setSegment(data.segmen_id);
        setListPrice(data.list_price);
        setSalePrice(data.sale_price);
        setVersion(data.version_name);
        setIdCar(data.id);
        setUpdate(true);
        setCreate(false);
        setShowPopup(true);
    };

    const cellRenderDelete = (data) => {
        let icon = <TrashIcon className="h-6 w-6 text-black cursor-pointer" onClick={() => { setShowPopupDelete(true); setIdCar(data.data.id) }} aria-hidden="true" />

        return icon
    };

    const deleteCar = () => {
        DynamicQueries.dataWithParameters('/deleteCar', 'cars', { id: idCar }).then((resp) => {
            setShowPopupDelete(false);
            getCarsData();
        })
    };

    useEffect(() => {
        getCarsData();
        getBrands();
        getModels();
        getSegments();
    }, [])

    return (
        <>
            <div className="flex mb-5 justify-between">
                <div>
                    <div className="relative pb-6">
                        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                            <h3 className="!text-2xl !ont-extrabold !tracking-tight !text-black md:!text-3xl lg:!text-4xl">Listado de Vehículos</h3>
                        </div>
                    </div>
                </div>

                <button
                    type="button"
                    className="inline-flex items-center px-6 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-[#144DC9] hover:bg-[#144DC9] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#144DC9]"
                    onClick={openPopup}
                >
                    Agregar Vehículo
                </button>
            </div>

            <div className="lg:grid lg:grid-cols-12 lg:gap-x-5">
                <div className="space-y-6 sm:px-6 lg:px-0 lg:col-span-12">
                    <div className="shadow-lg sm:rounded-md sm:overflow-hidden">
                        <div className="bg-gray-50 py-6 px-4 space-y-6 sm:p-6">
                            <div className="col-span-12 sm:col-span-3">
                                <DataGrid
                                    // ref={dataGridRef}
                                    dataSource={dataGrid}
                                    allowColumnReordering={true}
                                    allowColumnResizing={true}
                                    columnResizingMode="widget"
                                    columnAutoWidth={true}
                                    showRowLines={false}
                                    showBorders={true}
                                    rowAlternationEnabled={true}
                                    displayMode='full'
                                    style={{ height: '75vh', width: '100%' }}
                                >
                                    {/* <Selection
                                        mode="multiple"
                                        selectAllMode='allPages'
                                        showCheckBoxesMode='always'
                                    /> */}
                                    <FilterRow visible={true} />
                                    <FilterPanel visible={true} />
                                    <Scrolling rowRenderingMode='infinity'></Scrolling>
                                    <ColumnFixing enabled={true} />
                                    <HeaderFilter visible={true} />

                                    <Toolbar>
                                        <Item location="after">
                                            <Button2
                                                icon='refresh'
                                                onClick={getCarsData}
                                            />
                                        </Item>
                                        {/* <Item location="after">
                                            <Button2
                                                icon='xlsfile'
                                            // onClick={onExportXLS}
                                            />
                                        </Item> */}
                                    </Toolbar>

                                    <Column dataField='id' caption='ID'>
                                        <HeaderFilter allowSelectAll={true}>
                                            <Search enabled={true} />
                                        </HeaderFilter>
                                    </Column>

                                    <Column dataField='version_code' caption='Código' >
                                        <HeaderFilter allowSelectAll={true}>
                                            <Search enabled={true} />
                                        </HeaderFilter>
                                    </Column>

                                    <Column dataField='brand_name' caption='Marca' >
                                        <HeaderFilter allowSelectAll={true}>
                                            <Search enabled={true} />
                                        </HeaderFilter>
                                    </Column>

                                    <Column dataField='model_name' caption='Modelo' >
                                        <HeaderFilter allowSelectAll={true}>
                                            <Search enabled={true} />
                                        </HeaderFilter>
                                    </Column>

                                    <Column dataField='year_name' caption='Año'>
                                        <HeaderFilter allowSelectAll={true}>
                                            <Search enabled={true} />
                                        </HeaderFilter>
                                    </Column>

                                    <Column dataField='version_name' caption='Versión' >
                                        <HeaderFilter allowSelectAll={true}>
                                            <Search enabled={true} />
                                        </HeaderFilter>
                                    </Column>

                                    <Column dataField='segment_name' caption='Segmento' >
                                        <HeaderFilter allowSelectAll={true}>
                                            <Search enabled={true} />
                                        </HeaderFilter>
                                    </Column>

                                    <Column dataField='list_price' caption='Precio de lista' >
                                        <HeaderFilter allowSelectAll={true}>
                                            <Search enabled={true} />
                                        </HeaderFilter>
                                    </Column>

                                    <Column dataField='sale_price' caption='Precio de venta' >
                                        <HeaderFilter allowSelectAll={true}>
                                            <Search enabled={true} />
                                        </HeaderFilter>
                                    </Column>

                                    <Column
                                        alignment={'center'}
                                        allowFiltering={false}
                                        cellRender={(data) => cellRenderEdit(data)}
                                    />

                                    <Column
                                        alignment={'center'}
                                        allowFiltering={false}
                                        cellRender={(data) => cellRenderDelete(data)}
                                    />
                                </DataGrid>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Popup
                width={"75%"}
                height={"85%"}
                visible={showPopup}
                onHiding={hidePopup}
                showTitle={true}
                title={"Agregar Vehículo"}
                showCloseButton={true}
            >
                <ToolbarItem
                    widget="dxButton"
                    toolbar="top"
                    location="after"
                    cssClass="save-toolbar-button"
                    options={saveButtonCarOptions}
                />
                {/* <ScrollView width='100%' height='100%'> */}
                <div className="lg:grid lg:grid-cols-12 lg:gap-x-5">
                    <div className="space-y-6 sm:px-6 lg:px-0 lg:col-span-12">
                        <div className="shadow-lg sm:rounded-md sm:overflow-hidden">
                            <div className="bg-gray-50 py-6 px-4 space-y-6 sm:p-6">
                                <div className="grid grid-cols-6 gap-6">
                                    <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                        <label className="block text-sm font-medium text-gray-700">
                                            Código {' '}
                                        </label>
                                        <input
                                            type="number"
                                            name="code"
                                            id="code"
                                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                            value={code}
                                            onChange={(e) => {
                                                setCode(Number(e.target.value))
                                            }}
                                        />
                                    </div>

                                    <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                        <label className="block text-sm font-medium text-gray-700">
                                            Marca {' '}
                                        </label>
                                        <select
                                            id="brand"
                                            name="brand"
                                            className="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                            value={brand}
                                            onChange={(e) => {
                                                setBrand(Number(e.target.value))
                                            }}
                                        >
                                            {dataBrands.map((brand) => {
                                                return (
                                                    <option key={brand.id} value={brand.id}>{brand.name}</option>
                                                )
                                            })}
                                        </select>
                                    </div>

                                    <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                        <label className="block text-sm font-medium text-gray-700">
                                            Modelo {' '}
                                        </label>
                                        <select
                                            id="model"
                                            name="model"
                                            className="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                            value={model}
                                            onChange={(e) => {
                                                setModel(Number(e.target.value))
                                            }}
                                        >
                                            {dataModels.map((model) => {
                                                return (
                                                    <option key={model.id} value={model.id}>{model.name}</option>
                                                )
                                            })}
                                        </select>
                                    </div>

                                    <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                        <label className="block text-sm font-medium text-gray-700">
                                            Año {' '}
                                        </label>
                                        <input
                                            type="number"
                                            name="year"
                                            id="year"
                                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                            value={year}
                                            onChange={(e) => {
                                                setYear(Number(e.target.value))
                                            }}
                                        />
                                    </div>

                                    <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                        <label className="block text-sm font-medium text-gray-700">
                                            Segmento{' '}
                                        </label>
                                        <select
                                            id="segment"
                                            name="segment"
                                            className="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                            value={segment}
                                            onChange={(e) => {
                                                setSegment(Number(e.target.value));
                                            }}
                                        >
                                            {dataSegments.map((segment) => {
                                                return (
                                                    <option key={segment.id} value={segment.id}>{segment.name}</option>
                                                )
                                            })}
                                        </select>
                                    </div>

                                    <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                        <label className="block text-sm font-medium text-gray-700">
                                            Precio de lista {' '}
                                        </label>
                                        <input
                                            type="number"
                                            name="listPrice"
                                            id="listPrice"
                                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                            value={listPrice}
                                            onChange={(e) => {
                                                setListPrice(Number(e.target.value))
                                            }}
                                        />
                                    </div>

                                    <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                        <label className="block text-sm font-medium text-gray-700">
                                            Precio de venta {' '}
                                        </label>
                                        <input
                                            type="number"
                                            name="salePrice"
                                            id="salePrice"
                                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                            value={salePrice}
                                            onChange={(e) => {
                                                setSalePrice(Number(e.target.value))
                                            }}
                                        />
                                    </div>

                                    <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                        <label className="block text-sm font-medium text-gray-700">
                                            Versión {' '}
                                        </label>
                                        <div className="mt-1">
                                            <textarea
                                                rows={1}
                                                name="version"
                                                id="version"
                                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                value={version}
                                                onChange={(e) => {
                                                    setVersion(e.target.value)
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* </ScrollView> */}
            </Popup>

            <Popup
                width={"50%"}
                height={"50%"}
                visible={showPopupDelete}
                onHiding={() => setShowPopupDelete(false)}
                showTitle={true}
                title="Eliminar Vehículo"
                showCloseButton={true}
            >
                <div className="form-container text-center">
                    <div className="flex justify-center">
                        <ExclamationTriangleIcon className="h-24 w-24 text-red-700" />
                    </div>
                    <h5 className='mb-3'>¿Seguro que desea eliminar este registro?</h5>
                    <p className='mb-3'>Esta acción no puede revertirse</p>
                    <div className="d-flex text-center col-md-12 button_popup">
                        <Button2
                            onClick={() => deleteCar()}
                            className="btn btn-outline-primary mr-5"
                        >
                            Sí, eliminar
                        </Button2>
                        <Button2
                            onClick={() => setShowPopupDelete(false)}
                            className="btn btn-outline-secondary"
                        >
                            Cancelar
                        </Button2>
                    </div>
                </div>
            </Popup>
        </>
    )
}

export default CarList